module.exports = __webpack_public_path__ + "img/product4.21d9e500.png";